import React, { ReactNode } from "react";
import { FaTimes } from "react-icons/fa";

type DrawerProps = {
    open: boolean;
    children: ReactNode | ReactNode[];
    title: string;
    description?: string;
    handleClose: () => void;
};

const DrawerPanel = ({
    open,
    title,
    children,
    handleClose,
    description,
}: DrawerProps) => (
    <>
        <div
            data-testid="drawer-panel"
            className={
                open
                    ? "h-screen bg-white p-5 z-50 fixed top-0 bottom-0 right-0 left-auto w-80 sm:w-96 overflow-x-hidden overflow-y-scroll"
                    : "hidden"
            }
        >
            <div className="flex justify-end">
                <button type="button" onClick={handleClose}>
                    <FaTimes size={20} />
                </button>
            </div>
            <div className="font-gilroyBold font-extrabold text-lg sm:text-xl text-[#101828] pb-1">
                {title}
            </div>
            <div className="text-sm font-avenirBook pb-5 text-[#667085]">
                {description}
            </div>
            {children}
        </div>

        {/* overlay */}
        <div
            className={
                open
                    ? "fixed z-40 top-0 bottom-0 right-0 left-0 overflow-hidden bg-black opacity-40 h-full"
                    : "hidden"
            }
            onClick={handleClose}
            role="none"
        />
    </>
);

DrawerPanel.defaultProps = {
    description: "",
};

export default DrawerPanel;
